<template>
    <button
        class="menu-item"
        :class="{'is-active': props.item.isActive ? props.item.isActive() : null}"
        :title="props.item.title"
        @click="props.item.action"
    >
        <svg class="remix">
            <use :xlink:href="`${remixiconUrl}#ri-${props.item.icon}`" />
        </svg>
    </button>
</template>

<script setup lang="ts">
    import type {PropType} from 'vue';
    import {computed} from 'vue';
    import remixiconUrl from 'remixicon/fonts/remixicon.symbol.svg?url' with {type: 'svg'};
    import type {Item} from '../Item';

    const props = defineProps({
        item: {type: Object as PropType<Item>, required: true},
    });

    computed(() => {
        return {
            isActive: props.item.isActive ? props.item.isActive() : null,
        };
    });
</script>

<style lang="scss" scoped>
    .menu-item {
        background: transparent;
        border: none;
        border-radius: var(--joy-core-radius-3);
        color: var(--joy-color-neutral-50);
        cursor: pointer;
        height: 2.25rem;
        padding: 0.25rem;
        margin-right: 0.25rem;
        width: 1.75rem;

        svg {
            fill: currentColor;
            height: 100%;
            width: 100%;
        }

        &.is-active,
        &:hover {
            background-color: var(--joy-color-information-10);
        }
    }
</style>
